"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h3", {
  className: "text-primary"
}, "The Application Process"), /*#__PURE__*/_react.default.createElement("p", null, "In order to process an application and the gathering of yearbook data, an application will always have a status that says what stage it has reached"), /*#__PURE__*/_react.default.createElement("dl", {
  className: "row clearfix"
}, /*#__PURE__*/_react.default.createElement("dt", {
  className: "col-sm-3"
}, "Applied For"), /*#__PURE__*/_react.default.createElement("dd", {
  className: "col-sm-9"
}, "The default status when an applicant adds the application to the calendar. Most applications will stay in this state until the ACM."), /*#__PURE__*/_react.default.createElement("dt", {
  className: "col-sm-3"
}, " Declined"), /*#__PURE__*/_react.default.createElement("dd", {
  className: "col-sm-9"
}, "Only the calendar officer can move an application into this state. The applicant can then either modify the application (which will reset the status to applied for) or delete the application"), /*#__PURE__*/_react.default.createElement("dt", {
  className: "col-sm-3"
}, "Yearbook Data Requested"), /*#__PURE__*/_react.default.createElement("dd", {
  className: "col-sm-9"
}, "Once the calendar has been accepted the calendar officer will request detailed information for the yearbook and the managed calendar. This will send an email to the applicant and set the status for the application."), /*#__PURE__*/_react.default.createElement("dt", {
  className: "col-sm-3"
}, "Yearbook Data Submitted"), /*#__PURE__*/_react.default.createElement("dd", {
  className: "col-sm-9"
}, "Once yearbook data has been added by the applicant (see MyApplications tab and click edit), the applicant clicks the button to submit. Note that whilst yearbook data can be updated prior to the ACM it cannot be submitted until it has been requested."), /*#__PURE__*/_react.default.createElement("dt", {
  className: "col-sm-3"
}, "Accepted"), /*#__PURE__*/_react.default.createElement("dd", {
  className: "col-sm-9"
}, "Only the calendar officer can accept an application. Once accepted it cannot be updated. Only accepted applications will be exported to the yearbook and the managed calendar")), /*#__PURE__*/_react.default.createElement("p", null, "The following shows the route(s) that an application can take through the process."), /*#__PURE__*/_react.default.createElement("img", {
  src: "/public/applicationStatus.png",
  className: "img-fluid",
  alt: "Changing status of an application"
}), /*#__PURE__*/_react.default.createElement("br", null));
const ApplicationStatusHelp = () => {
  return _ref;
};
var _default = exports.default = ApplicationStatusHelp;